import React, {Component} from 'react';

import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import './Button.css';


let dumbButton = dumbBem('l-button');
let ButtonWrp = tx(dumbButton)('div');


export class Button extends Component {
  render() {
    return (
      <ButtonWrp
        onClick={this.props.onClick}
        modifier={this.props.modifier || ''}
      >
        {this.props.children}
      </ButtonWrp>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/landing/components/button/Button.jsx